import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebaseConfig/FirebaseConfig';

const useUserSnapshot = (currentUserId) => {

    const [notificationCount, setNotificationCount] = useState(0);
    const [jobInvitationCount, setJobInvitationCount] = useState(0);
    const [emailCount, setEmailCount] = useState(0);

    useEffect(() => {
        if (currentUserId) {
            const userRef = doc(db, 'users', currentUserId);

            const unsubscribe = onSnapshot(userRef, (docSnap) => {
                if (docSnap.exists()) {
                    const userData = docSnap.data();
                    setNotificationCount(userData?.notification || 0);
                    setJobInvitationCount(userData?.jobOffer || 0);
                    setEmailCount(userData?.emailCount || 0);
                } else {
                    console.log("No such document!");
                }
            });

            return () => unsubscribe();
        }
    }, [currentUserId]);

    return { notificationCount, jobInvitationCount, emailCount };
};

export default useUserSnapshot;